<template>
	<app-page>
		<app-heading title="Amenities" />
		<app-filter :value="hasFilters" @click="applyFilters()">
			<app-row no-padding>
				<app-cell cols="12" sm="6" md="4">
					<input-switch
						v-model="filters.featured_only"
						label="Show featured only"
						dense
					/>
				</app-cell>
			</app-row>
		</app-filter>
		<app-row>
			<app-cell>
				<app-data-table
					:items="amenities"
					:total="count"
					:headers="headers"
					@update="fetchAmenities"
				>
					<template v-slot:featured="{ item }">
						{{ item.featured ? 'Yes' : 'No' }}
					</template>
					<template v-slot:always_visible="{ item }">
						{{ item.always_visible ? 'Yes' : 'No' }}
					</template>
					<template v-slot:icon="{ item }">
						<span v-if="!item.icon || item.icon === ''" class="text-muted" style="font-style: italic;">None</span>
						<span v-else>
							<v-icon>mdi-{{ item.icon }}</v-icon>
							<span class="ml-2">{{ item.icon }}</span>
						</span>
					</template>
					<template v-slot:metadata="{ item }">
						<app-json v-if="item.metadata" :data="item.metadata" />
						<span v-else class="text-muted">—</span>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
import filters from '@/mixins/filters'

export default {
	mixins: [filters],
	data() {
		return {
			amenities: [],
			count: -1,
			filters: {
				featured_only: false,
			},
			headers: [{
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Category',
				value: 'category_name',
				sortable: false,
			}, {
				text: 'Featured',
				value: 'featured',
				sortable: false,
			}, {
				text: 'Always Visible',
				value: 'always_visible',
				sortable: false,
			}, {
				text: 'Icon',
				value: 'icon',
				sortable: false,
			}, {
				text: 'Metadata',
				value: 'metadata',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchAmenities(pagination) {
			const request = this.$ravello.graphql('amenities')
				.fields(['_id', 'studeo_id', 'metadata', 'translations', 'featured', 'always_visible', 'icon'])
				.include(this.$ravello.graphql('category').field('translations'))
				.fromPagination(pagination)

			if (this.appliedFilters.featured_only) {
				request.filter('featured', true)
			}

			if (this.count === -1) {
				request.count('count')
			}

			try {
				const amenities = await request.query()
				// Extract name from translations.en and category name from category.translations.en
				this.amenities = amenities.map(amenity => ({
					...amenity,
					name: this.getTranslation(amenity.translations, 'en'),
					category_name: amenity.category ? this.getTranslation(amenity.category.translations, 'en') : '',
				}))
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		getTranslation(translations, lang = 'en') {
			if (!translations) return ''
			if (typeof translations === 'string') return translations
			if (translations[lang]) return translations[lang]
			// Fallback to first available translation
			const keys = Object.keys(translations)
			return keys.length > 0 ? translations[keys[0]] : ''
		},
	},
}
</script>

